"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postFlowEventRequest = void 0;
const typebox_1 = require("@sinclair/typebox");
const web_core_event_1 = require("./web-core-event");
const StringOrNumber = typebox_1.Type.Union([typebox_1.Type.String(), typebox_1.Type.Number()]);
// TODO bring in the types from https://github.com/checkatrade/core-libs-analytics-frontend
exports.postFlowEventRequest = typebox_1.Type.Composite([
    web_core_event_1.WebCoreEvent,
    typebox_1.Type.Object({
        flow_id: typebox_1.Type.Union([
            typebox_1.Type.Literal(1),
            typebox_1.Type.Literal(7),
            typebox_1.Type.Literal(8),
            typebox_1.Type.Literal(9),
        ]),
        enrollment_id: typebox_1.Type.String(),
        current_step_id: typebox_1.Type.Optional(StringOrNumber),
        prev_step_id: typebox_1.Type.Optional(StringOrNumber),
        extra_params: typebox_1.Type.Optional(typebox_1.Type.Unknown()),
        app_platform: typebox_1.Type.Union([
            typebox_1.Type.Literal('web'),
            typebox_1.Type.Literal('ios'),
            typebox_1.Type.Literal('android'),
        ]),
    }),
], {
    description: 'Structured analytics flow event',
    examples: [
        {
            event_name: 'step_changed',
            ts: '2024-08-29T13:16:08.843Z',
            ts_local: '2024-08-29T14:16:08.000Z',
            app_version: 'adam-special',
            environment: 'development',
            user_id: null,
            session: '05468def-690e-4e12-8a71-5571e359d590',
            device_id: '11d06e15-fc21-4bbd-bc6a-f0e151e0d24f',
            flow_id: 9,
            enrollment_id: '0982f7bf-a498-4024-a996-6045d6c6b385',
            current_step_id: 300005,
            prev_step_id: 300005,
            extra_params: {
                type: 'DirectMessage',
                class_id: 12,
                postcode: 'SO20 6AD',
                company_id: 1063,
            },
            app_platform: 'web',
        },
    ],
});
//# sourceMappingURL=post-flow-event-request.js.map